import React from 'react';
import Icon from 'assets/Icon';
import styles from './style/badge.module.css';

interface BadgeProps {
  badgeStyle?: string,
  icon?: string,
  label: string,
}

const Badge = ({ badgeStyle, icon, label }:BadgeProps) => {
  function iconFill() {
    switch (badgeStyle) {
      case 'success':
        return 'fresh-green';
      case 'error':
        return 'strawberry'
      case 'warning':
        return 'fresh-yellow-700'
      case 'info':
        return 'blueberry'
      default:
        return 'black';
    }
  } 
  return (
    <div className={`${styles.badge} ${badgeStyle && styles[badgeStyle]} body2`}>
      { icon && (
        <Icon fill={iconFill()} icon={icon} size={16} />
      )}
      <span className="body2">{ label }</span>
    </div>
  );
}

Badge.defaultProps =  {
  badgeStyle: '',
  icon: '',
}

export default Badge;
